import { render } from "./SumCaptchaTypeComponent.vue?vue&type=template&id=616884ae&scoped=true"
import script from "./SumCaptchaTypeComponent.vue?vue&type=script&lang=js"
export * from "./SumCaptchaTypeComponent.vue?vue&type=script&lang=js"

import "./SumCaptchaTypeComponent.vue?vue&type=style&index=0&id=616884ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616884ae"]])

export default __exports__